import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Matricula } from 'src/app/models/matriculas.model';
import { AuthService } from 'src/app/services/auth.service';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';

declare var $: any;

@Component({
  selector: 'app-admision',
  templateUrl: './admision.component.html',
  styleUrls: []
})
export class AdmisionComponent implements OnInit {

  @Input() proceso: Matricula;

  @Output() onCancelProceso: EventEmitter<Matricula> = new EventEmitter();

  procesando: boolean = false
  user: any

  constructor(
    private router: Router,
    private procesoMatriculaService: ProcesoMatriculaService,
    private alerts: ToastrService,
    private auths: AuthService,
  ) { }

  ngOnInit(): void {
    this.user = this.auths.GetUserToken();
  }

  ActualizarProceso() {
    if (!this.user) {
      return;
    }

    if (this.TieneBloqueoAcademico()) {
      this.openModalBloqueoAcademico();
      //return
    }
    this.router.navigateByUrl(`/proceso/${this.proceso.IdProceso}`);
  }

  TieneBloqueoAcademico() {
    if (this.user.BloqueoAcademico && this.user.BloqueoAcademico === 'True')
      return true
    return false
  }

  openModalBloqueoAcademico() {
    $('#modalBloqueoAcademico').modal('show');
  }

  CancelarProceso() {
    if (this.TieneBloqueoAcademico()) {
      this.openModalBloqueoAcademico();
      //return
    }

    this.procesando = true
    this.procesoMatriculaService.desactivaSimulacion(this.proceso.IdProceso).subscribe(
      (data: any) => {
        if (!data.Error) {
          this.alerts.success('Proceso cancelado');
          this.onCancelProceso.emit(this.proceso);
        } else {
          this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
        }
      },
      (err) => {
        this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
        console.log(err)
      },
      () => {
        this.procesando = false
      }
    )
  }

}
